<template>
  <div class="tfa-status">
    <el-dialog
        title="Lock Account"
        :visible.sync="disabling"
        width="600px">
      <div>
        <label style="word-break: keep-all; font-size: 18px">
          Are you sure you want to disable this account?
        </label>
      </div>
      <br>
      <div>
        <input
            id="unlink_devices"
            v-model="unlinkDevices"
            type="checkbox">
        <label
            style="word-break: keep-all; font-size: 16px"
            for="unlink_devices">
          All client devices will be unlinked and all users will immediately lose access to the account.
        </label>
      </div>
      <div style="text-align: center; margin-top: 20px">
        <span>
          <el-button
              size="small"
              class="el-button el-button--info is-plain"
              @click="cancel">
            Cancel
          </el-button>
        </span>
        <span>
          <el-button
              size="small"
              type="primary"
              :disabled="!unlinkDevices"
              @click="lock">
            Lock Account
          </el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog
        title="Unlock Account"
        :visible.sync="enabling"
        width="600px">
      <div>
        <label style="word-break: keep-all;font-size: 18px">
          Are you sure you want to enable this account?
        </label>
      </div>
      <br>
      <div>
        <input
            id="verified_identity"
            v-model="accountVerfied"
            type="checkbox">
        <label
            style="word-break: keep-all; font-size: 16px"
            for="verified_identity">
          I certify that I have gone through the appropriate steps to ensure this account's protection and deem it safe to enabled.
        </label>
      </div>
      <div style="text-align: center; margin-top: 20px">
        <span>
          <el-button
              size="small"
              class="el-button el-button--info is-plain"
              @click="cancel">
            Cancel
          </el-button>
        </span>
        <span>
          <el-button
              size="small"
              type="primary"
              :disabled="!accountVerfied"
              @click="lock">
            Unlock Account
          </el-button>
        </span>
      </div>
    </el-dialog>
    <el-switch
        v-model="locked"
        size="small"
        active-text="YES"
        inactive-text="NO"
        :disabled="locking || disabling || enabling || !userHasPermission({permission: 'lock', on: 'Customer'})"
        @change="change" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import axios from "axios";
import { get } from "lodash";

import { EventBus } from "@/eventBus";

const { mapGetters: accountGetters } = createNamespacedHelpers("db/account");
const { mapGetters: authGetters } = createNamespacedHelpers("auth");
const { mapGetters: sharedGetters } = createNamespacedHelpers("shared");

export default {
  name: "LockAccountSwitch",
  data() {
    return {
      locked: false,
      locking: false,
      disabling: false,
      enabling: false,
      accountVerfied: false,
      unlinkDevices: false,
    };
  },
  computed: {
    ...accountGetters(["customer", "isLocked"]),
    ...authGetters(["user"]),
    ...sharedGetters(["userHasPermission"]),
  },
  mounted() {
    this.locked = this.isLocked;
  },
  methods: {
    cancel() {
      this.enabling = false;
      this.disabling = false;
      this.locked = this.isLocked;
    },
    change() {
      this.accountVerfied = false;
      this.unlinkDevices = false;
      if (this.isLocked) {
        this.enabling = true;
      } else {
        this.disabling = true;
      }
    },
    lock() {
      this.disabling = false;
      this.enabling = false;

      const url = this.isLocked
        ? `/v2/customers/${this.customer.id}/unlock`
        : `/v2/customers/${this.customer.id}/lock`;

      this.locking = true;
      axios
        .post(url)
        .then((response) => {
          const notifyMessage = this.isLocked
            ? "Account unlocked successfully."
            : "Account locked successfully.";
          this.$notify({
            title: this.isLocked ? "Unlocked Account" : "Locked Account",
            message: notifyMessage,
            type: "success",
          });

          this.$store.commit(
            "db/account/setSecurityStatus",
            get(response, "data.security_status", 1)
          );

          if (this.isLocked) EventBus.$emit("customer-account-locked");
          else EventBus.$emit("customer-account-unlocked");
        })
        .catch((error) => {
          this.$notify({
            title: this.isLocked ? "Unlock Account" : "Lock Account",
            message: `Unable to complete the account ${
              this.isLocked ? "enabling" : "disabling"
            }`,
            type: "error",
          });
          this.locked = this.isLocked;
          console.error(error);
        })
        .finally(() => (this.locking = false));
    },
  },
};
</script>

<style>
.tfa-status .el-switch__label > span {
  font-size: 14px;
}
.tfa-phone {
  display: block;
  margin: 7px 0;
}
</style>
